import type { InjectionKey } from 'vue'

import type { WorkbenchEvent } from './agent-workbench'
import type { VelisRuntimeSnapshot } from './velis-runtime-snapshot'

export interface WorkbenchSnapshotPublisher {
  publish: (snapshot: {
    events: WorkbenchEvent[]
    model: string
    phase: string
    provider: string
    sessionId: string
    runtime?: VelisRuntimeSnapshot
  }) => Promise<void>
}

/** Reduced MCP process facts. The reader omits commands, arguments, and environment values. */
export interface WorkbenchMcpServerFact {
  name: string
  state: 'running' | 'stopped' | 'error'
}

export interface WorkbenchMcpReader {
  read: () => Promise<WorkbenchMcpServerFact[]>
}

/** The desktop app owns the MCP status call. Stage Web has no reader. */
export const workbenchMcpReaderKey: InjectionKey<WorkbenchMcpReader> = Symbol('agent-workbench-mcp-reader')

/** The application owns IPC. The workbench owns the redacted timeline projection. */
export const agentWorkbenchSnapshotPublisherKey: InjectionKey<WorkbenchSnapshotPublisher> = Symbol('agent-workbench-snapshot-publisher')
